import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-gain-competitive-advantage',
  templateUrl: './gain-competitive-advantage.component.html',
  styleUrls: ['./gain-competitive-advantage.component.css']
})
export class GainCompetitiveAdvantageComponent {
  isBrowser:boolean=false;
  baseUrl = Constants.baseUrl;

  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/gain-a-competitive-advantage-with-erp/"
  },
  "headline": "Gain a Competitive Advantage with ERP",
  "description": "In the world of manufacturing, where everything hinges on how smoothly you can manage your supply chain, get products out the door, and keep your customers happy, being ahead of the curve isn't just nice—it's essential.",
  "image": "https://mitresource.com/assets/images/blogs/gain-competitive.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-04-24"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }


  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Gain a Competitive Advantage with ERP');

    this.metaService.addTags([
      { name: 'description', content: "In the world of manufacturing, where everything hinges on how smoothly you can manage your supply chain, get products out the door, and keep your customers happy, being ahead of the curve isn\'t just nice—it's essential." },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Gain a Competitive Advantage with ERP' },
      { property: 'og:url', content: 'https://mitresource.com/gain-a-competitive-advantage-with-erp/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/gain-competitive.png' },
      { property: "og:description', content: 'In the world of manufacturing, where everything hinges on how smoothly you can manage your supply chain, get products out the door, and keep your customers happy, being ahead of the curve isn\'t just nice—it's essential."},
    ]);
  }
}
